/**
 * Fixes the browser bfcache issue where checkout buttons remain disabled after navigating back from checkout.
 * On the cart page, cart items may persist incorrectly, so this script updates the `main-cart` section along with the cart bag in the header.
 *
 * This script:
 * - Refreshes specific Shopify sections using the Sections API (`?sections=...`).
 * - Ensures checkout buttons (cart drawer and reserve modal) are re-enabled if the cart has items.
 *
 * Notes:
 * - Uses the `pageshow` event to detect when a page is restored from bfcache.
 * - Sections refreshed: main cart (`#main-cart`) and header icons (`#cart-icon-bubble`).
 *
 * @listens pageshow
 * @see https://shopify.dev/docs/api/ajax/section-rendering
 * */
document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return; // Only handle bfcache restores
    console.log("Page restored from bfcache, refreshing cart sections...");
    /**
     * Sections to refresh after browser bfcache restore.
     */
    const SECTIONS = Object.freeze([
      {
        id: "main-cart",
        sectionDataId: document.getElementById("main-cart")?.dataset.id,
        selector: "#main-cart",
      },
      {
        id: "fp-header-icons",
        sectionDataId: document.getElementById("main-header")?.dataset.id,
        selector: "#cart-icon-bubble",
      },
    ]);

    const params = `?sections=${SECTIONS.map((s) => s.sectionDataId).join(",")}`;

    fetch(window.location.pathname + params)
      .then((res) => res.json())
      .then((data) => {
        SECTIONS.forEach((section) => {
          const html = data[section.sectionDataId];
          if (!html) return;

          const updated = new DOMParser().parseFromString(html, "text/html").querySelector(section.selector)?.innerHTML;

          const current = document.querySelector(section.selector);
          if (current && updated) current.innerHTML = updated;
        });
      })
      .catch((err) => console.error("Error refreshing sections:", err));

    // Ensure cart drawer and reserve modal checkout buttons are re-enabled if cart has items
    const checkoutButton = document.getElementById("CartDrawer-Checkout");
    const reserveModalCheckoutButton = document.querySelector(".fp-layaway-checkout");

    if (checkoutButton || reserveModalCheckoutButton) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (!cart.items?.length) return; // Empty cart, do nothing

          if (checkoutButton?.hasAttribute("disabled")) {
            checkoutButton.removeAttribute("disabled");
          }

          if (reserveModalCheckoutButton?.hasAttribute("disabled")) {
            reserveModalCheckoutButton.removeAttribute("disabled");

            // Reset reserve modal text
            reserveModalCheckoutButton.querySelector("#fp-layaway-checkout-text")?.style.removeProperty("display");
            reserveModalCheckoutButton
              .querySelector("#fp-layaway-processing-text")
              ?.style.setProperty("display", "none");
          }
        })
        .catch((err) => console.error("Error checking cart state:", err));
    }
  });
});
